import { Configuration } from '@shared/models/configuration';

// @dynamic
export class InboxConfig {

  private static get InboxApi(): string {
    return Configuration.getConfig('AlertApi');
  }

  static  getMailByIdApi(id): string {
    return `${InboxConfig.InboxApi}PlatformMail/MailById?mailId=${id}`;
  }
  public static getReplyPlatformMailApi(): string {
    return `${InboxConfig.InboxApi}Command/ReplyPlatformMail`;
  }
  public static getMarkMailAsReadApi(): string {
    return `${InboxConfig.InboxApi}Command/MarkMailAsRead`;
  }

  public static  getAllRecepientsApi(): string {
    return `${InboxConfig.InboxApi}PlatformMail/MailRecepients`;
  }
  public static getAllMailsByLabel(label): string {
    return `${InboxConfig.InboxApi}PlatformMail/Mails?label=${label}`;
  }
}
